import React from "react";
import {
  Box,
  Typography,
  Divider,
  Container,
  Link,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

const Section = ({ title, children }) => (
  <Box sx={{ mt: 4 }}>
    <Typography variant="h5" gutterBottom fontWeight="bold">
      {title}
    </Typography>
    {children}
    <Divider sx={{ mt: 2 }} />
  </Box>
);

const PrivacyPolicy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h4" gutterBottom fontWeight="bold">
        Privacy Policy
      </Typography>
      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
        Last updated: April 19, 2025
      </Typography>

      <Typography variant="body1" paragraph>
        Welcome to <strong>Blue Bike</strong>, your trusted platform for buying
        and selling used bikes online. This Privacy Policy explains how we
        collect, use, disclose, and safeguard your information when you use our
        platform.
      </Typography>

      <Section title="1. Information We Collect">
        <List dense>
          <ListItem>
            <ListItemText primary="Personal Information: Name, phone number, and email address during registration." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Bike Listings: Details such as brand, model, year, price, and images." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Communication Data: Messages and inquiries between buyers and sellers." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Usage Data: Device, browser, and interaction information." />
          </ListItem>
        </List>
      </Section>

      <Section title="2. How We Use Your Information">
        <List dense>
          <ListItem>
            <ListItemText primary="To allow customers and dealers to list and explore bike listings." />
          </ListItem>
          <ListItem>
            <ListItemText primary="To facilitate safe communication between buyers and sellers." />
          </ListItem>
          <ListItem>
            <ListItemText primary="To improve the platform's features and user experience." />
          </ListItem>
          <ListItem>
            <ListItemText primary="To send service updates, promotions, or alerts with your consent." />
          </ListItem>
        </List>
      </Section>

      <Section title="3. Sharing Your Information">
        <Typography variant="body1" paragraph>
          We do not sell your personal information. Your contact details are
          shared only when a buyer expresses interest in a listing. Customers
          and dealers are responsible for the public data they choose to share
          in listings.
        </Typography>
      </Section>

      <Section title="4. Data Security">
        <Typography variant="body1" paragraph>
          We use secure servers, encryption, and authentication protocols to
          protect your data. However, please note that no method of online
          transmission is completely secure.
        </Typography>
      </Section>

      <Section title="5. Your Choices">
        <List dense>
          <ListItem>
            <ListItemText primary="You can update or remove your listings at any time." />
          </ListItem>
          <ListItem>
            <ListItemText
              primary={
                <>
                  You can request account deletion by contacting us at{" "}
                  <Link href="mailto:support@bluebike.in">
                    support@bluebike.in
                  </Link>
                  .
                </>
              }
            />
          </ListItem>
        </List>
      </Section>

      <Section title="6. Children’s Privacy">
        <Typography variant="body1" paragraph>
          Blue Bike is not intended for individuals under 18 years of age. We do
          not knowingly collect personal data from children.
        </Typography>
      </Section>

      <Section title="7. Changes to This Policy">
        <Typography variant="body1" paragraph>
          We may update this Privacy Policy periodically. All updates will be
          posted on this page with the revised date.
        </Typography>
      </Section>

      <Section title="8. Contact Us">
        <Typography variant="body1">
          If you have any questions or concerns, feel free to reach out to us at{" "}
          <Link href="mailto:support@bluebike.in">support@bluebike.in</Link>.
        </Typography>
      </Section>
    </Container>
  );
};

export default PrivacyPolicy;
